import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./list.component.html?ngResource";
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ListboxModule } from 'primeng/listbox';
import { TooltipModule } from 'primeng/tooltip';
let ListComponent = class ListComponent {
    listType;
    items;
    selected;
    optionLabel;
    metaKey = false;
    multiple = false;
    selectionChange = new EventEmitter();
    optionClicked = new EventEmitter();
    selection;
    label = 'name';
    onSelectionChange() {
        this.selectionChange.emit(this.selection);
    }
    onOptionClicked(event) {
        this.optionClicked.emit(event);
    }
    ngOnChanges(changes) {
        if (changes?.selected) {
            this.selection = changes.selected.currentValue;
        }
        if (changes?.optionLabel) {
            this.label = changes.optionLabel.currentValue;
        }
    }
    static propDecorators = {
        listType: [{ type: Input }],
        items: [{ type: Input }],
        selected: [{ type: Input }],
        optionLabel: [{ type: Input }],
        metaKey: [{ type: Input }],
        multiple: [{ type: Input }],
        selectionChange: [{ type: Output }],
        optionClicked: [{ type: Output }]
    };
};
ListComponent = __decorate([
    Component({
        selector: 't20-list',
        template: __NG_CLI_RESOURCE__0,
        standalone: true,
        imports: [
            CommonModule,
            FormsModule,
            ListboxModule,
            TooltipModule,
        ],
    })
], ListComponent);
export { ListComponent };
